<template>
  <div style="colo" id="hh">
    <!-- <canvas id="renderCanvas" touch-action="none"></canvas> -->
    <!-- <v-btn text @click="createBabylon()"> push me! </v-btn> -->
    <!-- <babylon
      model="/static/assets/images/glb.glb"
      templates.main.params.fill-screen="true"
    ></babylon> -->

    <!-- model.animation.auto-start="true" -->
    <!-- templates.nav-bar="null" -->
    <!-- scene.debug="true" -->
    <babylon
      id="loading-demo"
      model.url="../assets/images/tiefighter_02.glb"
      templates.viewer.params.enable-drag-and-drop="true"
      templates.main.params.fill-screen="true"
      templates.nav-bar.html="<div/>"
      templates.loading-screen.params.background-color="#c3c3c3"
      templates.loading-screen.params.loading-image="null"
      templates.loading-screen.params.static-loading-image="/static/assets/final_gif.gif"
      camera.behaviors.auto-rotate="0"
      skybox="false"
      ground="false"
    >
    </babylon>
    <!-- <babylon id="babylon-viewer" camera.behaviors.auto-rotate="0"></babylon> -->
    <!-- <Scene style="background-color: transparent">
      <Asset src="/static/assets/images/tiefighter_02.glb" v-model="myAssetRoot"
        ><Animation :loop="false" :start="1" :end="10" :duration="5"></Animation
      ></Asset>
    </Scene> -->
    <!-- <v-btn text @click="startAnimation()"> push me! </v-btn>
    <v-btn text @click="createScene()"> push me! </v-btn> -->
  </div>
</template>


<script>
export default {
  name: "babylontest",
  components: {},
  data: function () {
    return {};
  },
  mounted() {
    // let babylonViewerScript = document.createElement("script");
    // babylonViewerScript.setAttribute(
    //   "src",
    //   "https://preview.babylonjs.com/viewer/babylon.viewer.js"
    // );
    // document.head.appendChild(babylonViewerScript);
    // let babylonViewerScript = document.createElement("script");
    // babylonViewerScript.setAttribute(
    //   "src",
    //   "https://www.babylonjs.com.cn/css/preview.babylonjs.com/viewer/babylon.viewer.js"
    // );
    // babylonViewerScript.async = true;
    // document.head.appendChild(babylonViewerScript);
    // var viewer = document.createElement("babylon");
    // viewer.setAttribute("id", "babylon-viewer");
    // viewer.setAttribute("camera.behaviors.auto-rotate", "0");
    // var hhh = document.getElementById("hh");
    // console.log(hhh);
    // hhh.appendChild(viewer);
    // BabylonViewer.viewerManager
    //   .getViewerPromiseById("babylon-viewer")
    //   .then(function (viewer) {
    //     // this will resolve only after the viewer with this specific ID is initialized
    //     viewer.onEngineInitObservable.add(function (scene) {
    //       viewer.loadModel({
    //         title: "Helmet",
    //         subtitle: "BabylonJS",
    //         thumbnail:
    //           "https://www.babylonjs.com/img/favicon/apple-icon-144x144.png",
    //         url: "/static/assets/images/tiefighter_02.glb",
    //       });
    //       console.log(scene);
    //     });
    //   });
  },

  methods: {
    // createScene() {
    //   // /* eslint-disable no-mixed-spaces-and-tabs */
    //   // alert("gjhg");
    //   // var engine = new BABYLON.Engine(true);
    //   // alert(engine);
    //   // var scene = new BABYLON.Scene(engine);
    //   // alert(scene);
    //   // var camera = new BABYLON.ArcRotateCamera(
    //   //   "Camera",
    //   //   -Math.PI / 2,
    //   //   Math.PI / 2,
    //   //   12,
    //   //   BABYLON.Vector3.Zero(),
    //   //   scene
    //   // );
    //   // alert(camera);
    //   // camera.attachControl(true);
    //   // /* eslint-enable no-mixed-spaces-and-tabs */
    //   //var tt = this.$refs["loading-demo"];
    //   let viewer = BabylonViewer.viewerManager.getViewerById("loading-demo");
    //   console.log(viewer);
    //   var engine = new BABYLON.Engine(viewer, true);
    //   console.log("gjhgk");
    //   var scene = new BABYLON.Scene(engine);
    //   console.log(scene);
    //   BABYLON.SceneLoader.ImportMesh(
    //     "",
    //     "/static/assets/images/",
    //     "tiefighter_02.glb",
    //     scene,
    //     function (newMeshes, particleSystems, skeletons) {
    //       //var dude = newMeshes[0];
    //       console.log(newMeshes + particleSystems + skeletons + "");
    //       // dude.rotationQuaternion = undefined;
    //       // dude.position = new BABYLON.Vector3(0, 0, -80);
    //       // //scene.beginAnimation(skeletons[0], 0, 100, true, 1.0);
    //       // scene.createDefaultCamera(1,1,1);
    //       // scene.beforeRender = () => {
    //       //     dude.rotation.y += 0.01;
    //       // };
    //     }
    //   );
    //   return scene;
    // },
    // startAnimation() {
    //   //var domElement = document.getElementById("loading-demo");
    //   // domElement.debug = "true";
    //   let viewer = new BabylonViewer.DefaultViewer();
    //   viewer = document.getElementById("loading-demo");
    //   //let viewer = BabylonViewer.viewerManager.getViewerById("loading-demo");
    //   console.log(viewer);
    //   // viewer.scene.debug = "true";
    //   // let viewer = new BabylonViewer.DefaultViewer(domElement, {
    //   //   scene: {
    //   //     debug: true,
    //   //   },
    //   //   camera: {
    //   //     behaviors: {
    //   //       autoRotate: 0,
    //   //     },
    //   //   },
    //   // });
    //   // console.log(scene);
    //   // console.log(scene.accessKey());
    //   // scene.beginAnimation();
    //   // console.log(scene);
    // },
    // createBabylon() {
    //   var canvas = document.getElementById("renderCanvas");
    //   var engine = new BABYLON.Engine(canvas, true);
    //   // This creates a basic Babylon Scene object (non-mesh)
    //   var scene = new BABYLON.Scene(engine);
    //   // This creates and positions a free camera (non-mesh)
    //   var camera = new BABYLON.FreeCamera(
    //     "camera1",
    //     new BABYLON.Vector3(0, 5, -10),
    //     scene
    //   );
    //   // This targets the camera to scene origin
    //   camera.setTarget(BABYLON.Vector3.Zero());
    //   // This attaches the camera to the canvas
    //   camera.attachControl(canvas, true);
    //   // This creates a light, aiming 0,1,0 - to the sky (non-mesh)
    //   var light = new BABYLON.HemisphericLight(
    //     "light",
    //     new BABYLON.Vector3(0, 1, 0),
    //     scene
    //   );
    //   // Default intensity is 1. Let's dim the light a small amount
    //   light.intensity = 0.7;
    //   // Our built-in 'sphere' shape.
    //   var sphere = BABYLON.MeshBuilder.CreateSphere(
    //     "sphere",
    //     { diameter: 2, segments: 32 },
    //     scene
    //   );
    //   // Move the sphere upward 1/2 its height
    //   sphere.position.y = 1;
    //   // Our built-in 'ground' shape.
    //   var ground = BABYLON.MeshBuilder.CreateGround(
    //     "ground",
    //     { width: 6, height: 6 },
    //     scene
    //   );
    //   console.log(ground);
    //   return scene;
    // },
  },
};
</script>

<style lang="scss" scoped>
// babylon {
//   max-width: 800px;
//   max-height: 500px;
//   width: 100%;
//   height: 600px;
// }
</style>






